import React, { Fragment } from "react";

import PageWrap from "@common/components/PageWrap/PageWrap";
import { Spinner } from "@common/components/Spinner/Spinner";
import { useAppContext } from "@main/context/App/App.context";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";

import PushNotificationsSettingsCard from "../../components/AppsCards/PushNotificationsSettingsCard";
import NoAppsView from "../../components/NoAppsView";
import useAppsUsersViewConsumer from "../../consumers/useAppsUsersViewConsumer";

export default function AppsUsersView(): JSX.Element {
  const { loading: appsLoading } = useAppContext();
  const { selectedWorkspace } = useAppSelectionContext();

  const { allApps, localSelectedApp, certificate, refetchCertificate, deleteCertificate } = useAppsUsersViewConsumer();

  if (!appsLoading && allApps.length === 0) {
    return (
      <PageWrap style={{ marginTop: "4rem" }}>
        <NoAppsView selectedWorkspace={selectedWorkspace} />
      </PageWrap>
    );
  }

  if (!localSelectedApp) {
    return <Spinner />;
  }

  return (
    <PageWrap style={{ marginTop: "4rem" }}>
      <Fragment>
        <PushNotificationsSettingsCard
          selectedDropdownApp={localSelectedApp}
          certificate={certificate}
          getCertificate={refetchCertificate}
          deleteCertificate={deleteCertificate}
          isSample={localSelectedApp.is_sample}
        />
      </Fragment>
    </PageWrap>
  );
}
